import React, {
  useEffect,
  useState,
  useContext,
} from 'react';
import Radioaizer from 'Global/Components/CommonComponents/Radioaizer/Radioaizer';
import DayButton from './DayButton';
import i18next from 'i18next';
import { useAtom } from 'jotai';
import _ from 'lodash';
import { selectedDayAtom } from 'Routes/Public/GetNewTurn/shared/selected.day';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';

const Days = ({ days }) => {
  const isHolidayEnabled = useContext(
    GlobalContext
  )?.appConfig?.filter(
    (fl) => fl.Key === 'webAppshowHolidays'
  );

  const [selectedDay, setSelectedDay] =
    useAtom(selectedDayAtom);

  // console.log('selectedDay->', selectedDay);

  useEffect(() => {
    setSelectedDay(days[0]);

    return () => {
      setSelectedDay(null);
    };
  }, []);

  // const findDuplicates = (arr) =>
  //   _.uniqBy(
  //     _.filter(
  //       arr,
  //       (item, index, self) =>
  //         _.findIndex(self, { Text: item.Text }) !== index
  //     ),
  //     'Text'
  //   ).map((item) => item.Text);

  // const duplicateItems = findDuplicates(days);

  const dayList = days?.filter((fl) => {
    if (
      isHolidayEnabled[0]?.Value?.toLowerCase() === 'true'
    ) {
      return fl;
    } else {
      return !fl?.dayName?.includes('H');
    }
  });

  return (
    <React.Fragment>
      <div
      // className={style.container}
      >
        <Radioaizer
          direction="row"
          elements={dayList?.map((day) => (
            <DayButton
              day={day}
              selectedDay={selectedDay}
              // duplicateItems={duplicateItems}
            />
          ))}
          onSelectFunction={(index) => {
            setSelectedDay(dayList[index]);
          }}
          justPassSelect={true}
          styles={{
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
            maxWidth: '92vw',
            flexDirection:
              i18next.language === 'fa' ||
              i18next.language === 'ar'
                ? 'row-reverse'
                : 'row',
          }}
          justifyContent="unset"
        />
      </div>
    </React.Fragment>
  );
};

export default Days;
